module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"gatsbyRemarkPlugins":["gatsby-remark-autolink-headers",{"resolve":"/opt/plugins/gatsby-remark-relative-markdown-image/index.js","options":{"pathPrefix":"/api-docs/v2"}},{"resolve":"gatsby-remark-prismjs","options":{"showLineNumbers":false}}],"defaultLayouts":{},"lessBabel":false,"remarkPlugins":[],"rehypePlugins":[],"mediaTypes":["text/markdown","text/x-markdown"],"root":"/opt"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
